module.exports = __webpack_public_path__ + "img/union.687862f3.png";